import { create } from 'zustand'
import { BreadCrumbItem } from '../components/bread-crumb'

/*
  Two separate slots instead of one shared `items` value, so ordering
  never matters: `autoItems` is written by layout/auth-layout.tsx on every
  route (the automatic Home/Section/Page trail derived from featuredPage),
  and `overrideItems` is written only by an individual page that wants a
  more specific custom trail (e.g. "Settings / Users / Jane Doe" instead
  of the generic "Settings / Users").

  Why not one shared value: React fires a CHILD component's effects
  before its PARENT's on mount. AuthAppLayout is the parent of every
  page, so if both wrote to the same `items` field, AuthAppLayout's own
  effect would always run right after a page's and silently clobber
  whatever custom breadcrumb that page had just set — the override would
  never stick, no matter what the page did. Keeping them in separate
  slots and letting the consumer (components/header.tsx) pick
  `overrideItems ?? autoItems` sidesteps effect ordering entirely: it
  doesn't matter which one was written most recently, only whether an
  override is currently present.
*/
interface useBreadCrumbEntity {
    autoItems: BreadCrumbItem[];
    overrideItems: BreadCrumbItem[] | null;
    setAutoBreadCrumb: (items: BreadCrumbItem[]) => void;
    setBreadCrumb: (items: BreadCrumbItem[]) => void;
    clearBreadCrumb: () => void;
}

export const useBreadCrumb = create<useBreadCrumbEntity>((set) => ({
    autoItems: [],
    overrideItems: null,
    setAutoBreadCrumb: (autoItems) => set(() => ({ autoItems })),
    setBreadCrumb: (overrideItems) => set(() => ({ overrideItems })),
    clearBreadCrumb: () => set(() => ({ overrideItems: null }))
}))
